(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ErrorMessages', ErrorMessages);

    ErrorMessages.$inject = ['$resource'];

    function ErrorMessages ($resource) {
        var resourceUrl =  'api/error-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            
            'getErrorMessageForCode': {
                method: 'GET',
                params: {code:'@code'},
                url: 'api/error-message-for-code/:code',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
